import GraphQL from './GraphQL'

class PickPointsClass {
    getPoints(cb, DELIVERY_CODE, ADDRESS_RECIPIENT='') {
        GraphQL.query('get_pick_points', {
            'DELIVERY_CODE : String!' : DELIVERY_CODE,
            'ADDRESS_RECIPIENT : String!' : ADDRESS_RECIPIENT,
        }, {}, (err, res) => {
            if (cb) {
                if (err) {
                    cb(err, res)
                } else {
                    try {
                        const points = JSON.parse(res)

                        cb(null, points)
                    } catch(e) {
                        cb(e, null)
                    }
                }
            }
        })
    }
}

const PickPoints = new PickPointsClass()

/*
PickPoints.getPoints((err, res) => {
    console.log(err, res)
}, 'YANDEX_DELIVERY')
*/

export default PickPoints